/**
 * Created by Ning Jiang on 2022-06-15.
 */

import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {Serial} from "../Serial";

export class WinCapBetPresentation implements FlowStatePresentation {

    constructor() {}

    public async start(flowStateController:FlowStateController):Promise<any> {
        await Serial.winCapController.wait();
        flowStateController.finish();
    }
}